export { default as default } from './KitSection';
